export default __webpack_public_path__ + "static/diplomats_Advocate_INFJ_conclusion-553faed41d23573ee30e931fd324e457.svg";